import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as LogbookAppReducer from '../logbook.reducer';
import * as ObjectActions from './formio-role-checker.actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import * as AppActions from '../app/actions';
import { IGetManyResponse, IGetOneResponse } from '../../shared/model/interface/crud-response-interface.model';
import { FormioRoleCheckerService } from './formio-role-checker.service';
import { IFormioRoleCheckerEventResponse, IRoleDataResponse } from './formio-role-checker.model';

@Injectable()
export class FormioRoleCheckerEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<LogbookAppReducer.LogbookAppState>,
    private readonly formioRoleCheckerService: FormioRoleCheckerService,
  ) {}

  createFormioESignEventEffect = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.CONTROL_ROLE_FORMIO_ROLE_CHECKER),
      switchMap((objectData: ObjectActions.ControlRoleFormioRoleChecker) => {
        this.store.dispatch(new AppActions.ShowLoader());
        return this.formioRoleCheckerService.controlFormioRoleChecker(objectData.payload).pipe(
          switchMap((response: IGetOneResponse<IFormioRoleCheckerEventResponse>) => {
            return of(new ObjectActions.ControlRoleFormioRoleCheckerCompleted(response), new AppActions.HideLoader());
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );

  getRoleForFormioComponent = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.GET_ROLES_FOR_FORMIO_COMPONENT),
      switchMap((objectData: ObjectActions.GetRolesForFormioComponent) => {
        return this.formioRoleCheckerService.getRoleData(this.formioRoleCheckerService.getRoleDataParams()).pipe(
          switchMap((response: IGetManyResponse<IRoleDataResponse>) => {
            return of(new ObjectActions.GetRolesForFormioComponentCompleted(response));
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );

  getPreviewRoleTitles = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.GET_PREVIEW_ROLE_TITLES),
      switchMap(() => {
        return this.formioRoleCheckerService.getRoleData(this.formioRoleCheckerService.getRoleDataParams()).pipe(
          switchMap((response: IGetManyResponse<IRoleDataResponse>) => {
            return of(new ObjectActions.GetPreviewRoleTitlesCompleted(response));
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.GetPreviewRoleTitlesFailed(errorRes));
          }),
        );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.GetPreviewRoleTitlesFailed(errorRes));
      }),
    ),
  );
}
